// @flow
import * as React from 'react';
import PropTypes from 'prop-types';
import {ExpandMoreRounded, ExpandLessRounded} from '@material-ui/icons';
import {Collapse, Typography, Divider} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {colors} from '../../assets/styles/colors';

type Props = {|
  children: any,
  startIcon?: React.Node,
  title: React.Node | string,
  startClosed?: boolean,
  className?: string,
  paddingV?: number,
  paddingH?: number,
  divisible?: boolean,
  titleEndContent?: React.Node,
|};

const useStyles = props =>
  makeStyles(theme => ({
    root: {
      marginTop: theme.spacing(3),
      backgroundColor: 'white',
      borderRadius: '12px',
      boxShadow:
        '0px 0px 1px rgba(40, 41, 61, 0.08), 0px 0.5px 2px rgba(96, 97, 112, 0.16)',
      [theme.breakpoints.down('xs')]: {
        // padding: theme.spacing(2),
        marginTop: theme.spacing(2),
      },
    },
    title: {
      color: colors.grey900,
      fontWeight: 600,
      display: 'flex',
      // alignItems: 'center',
      padding: theme.spacing(
        props.paddingV ? props.paddingV : 2,
        props.paddingH ? props.paddingH : 3
      ),
      cursor: 'pointer',
      justifyContent: 'space-between',
    },
    titleBetween: {
      alignItems: 'center',
    },
    childrenArea: {
      padding: theme.spacing(
        props.paddingV ? props.paddingV : 2,
        props.paddingH ? props.paddingH : 3
      ),
      paddingTop: 0,
    },
    content: {
      marginTop: theme.spacing(props.paddingV ? props.paddingV : 2),
      cursor: 'default',
    },
    divider: {
      background: colors.grey300,
    },
    noMarginTop: {
      marginTop: 0,
    },
    between: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }));

export default function Collapsible(props: Props) {
  const {
    children,
    startIcon,
    title,
    startClosed,
    className,
    divisible = true,
    titleEndContent,
  } = props;
  const classes = useStyles(props)();

  const [open, setOpen] = React.useState(startClosed ? false : true);

  return (
    <div className={`${classes.root} ${className ? className : ''}`}>
      <Typography
        component="div"
        className={classes.title}
        onClick={() => setOpen(prev => !prev)}
      >
        <div
          style={{display: 'flex', alignItems: 'center', gap: 8, flexGrow: 1}}
        >
          {startIcon ? startIcon : null}
          {title}
        </div>
        {titleEndContent ? titleEndContent : null}
        {open ? <ExpandLessRounded /> : <ExpandMoreRounded />}
      </Typography>
      <Collapse in={open}>
        <div className={classes.childrenArea}>
          {divisible && <Divider className={classes.divider} />}
          <div className={classes.content} onClick={e => e.stopPropagation()}>
            {children}
          </div>
        </div>
      </Collapse>
    </div>
  );
}

Collapsible.propTypes = {
  children: PropTypes.node.isRequired,
  startIcon: PropTypes.object,
  title: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.string.isRequired,
  ]),
  startClosed: PropTypes.bool,
  className: PropTypes.string,
  paddingV: PropTypes.number,
  paddingH: PropTypes.number,
};
